module.exports = __webpack_public_path__ + "static/media/Receipts.53309090.svg";